export const SET_JURISDICTIONS = 'jurisdictions/SET_JURISDICTIONS';
